import _ from 'lodash';
import React from 'react';

import { errorUtil, fields } from 'iron-forge-react-modules';
import { FormModal, SelectItemsModal } from 'modules';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [
    saveListingManagementStrategyTemplateGroup
  ] = dataService.useSaveListingManagementStrategyTemplateGroup();
  const [isSelectingItems, setIsSelectingItems] = React.useState(false);
  const [submittedFormState, setSubmittedFormState] = React.useState<types.IFormState>({
    name: '',
    items: []
  });
  const form = useForm<types.IFormState>({ defaultValues: submittedFormState });



  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      setSubmittedFormState(formState);
      if (!isSelectingItems) {
        setIsSelectingItems(true);
      } else {
        if (!_.isEmpty(formState.items) && formState.name) {
          await errorUtil.errorWrap(async () => {
            props.onClose();
            await saveListingManagementStrategyTemplateGroup(formState);
          }, {});
        }
      }
    },
    [
      props,
      isSelectingItems,
      saveListingManagementStrategyTemplateGroup
    ]
  );



  return !isSelectingItems ? (
    <FormModal.FC
      title="New Template"
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}>
      <ControlledTextField
        label="Template name"
        formControl={form.control}
        fieldKey="name"
        isRequired />
    </FormModal.FC>

  ) : (

    <SelectItemsModal.FC
      selectedItemIds={[]}
      onSubmit={items => {
        processSubmit({
          ...submittedFormState,
          items
        });
      }}
      onClose={props.onClose} />
  );
};
